<template>

  <template v-if="currentPage === 1">
    <div class="vc-builder__wrapper items-center">
      <div class="vc-builder__container container">
        <p class="mb-12 text-3xl font-bold text-center">Let's start by getting your email</p>
        <div class="max-w-sm mx-auto">
          <div v-if="errorMessage" class="bg-form-error p-4 mb-5 font-semibold text-white rounded-lg">
            {{ errorMessage }}
          </div>
          <label for="email_address">Your Email Address</label>
          <input v-model="emailAddress" id="email_address" name="email_address" type="email" placeholder="name@example.com">
        </div>
        <p class="mt-10 text-center">
          <button class="btn" type="button" @click="submitEmail()">Continue</button>
        </p>
      </div>
    </div>
  </template>

  <template v-if="currentPage === 2 && existingBuilds">
    <div class="vc-builder__wrapper items-center">
      <div class="vc-builder__container container">
        <div class="max-w-4xl mx-auto">
          <div class="flex">
            <div class="flex-initial">
              <p class="mb-4 text-3xl font-bold">Welcome back!</p>
              <p class="mb-12 text-xl font-medium">Would you like to pick up from where you left off?</p>
            </div>
            <div class="flex-initial flex-shrink-0 ml-auto">
              <button class="btn flex items-center" type="button" @click="startNewBuild()"><svg class="icon icon-plus mr-2"><use xlink:href="#icon-plus"></use></svg> Start New Build</button>
            </div>
          </div>

          <ul class="vc-builder__existing-build-list">
            <li v-for="existingBuild in existingBuilds" :key="existingBuild.ID" class="last:mb-0 flex items-center px-8 py-4 mb-4 rounded-lg">
              <div>
                <span class="block mb-1 font-bold">{{ existingBuild.post_title }}</span>
                <span class="block text-sm text-gray-600">Last edited {{ formatDateTime( existingBuild.post_modified ) }}</span>
              </div>
                <button class="btn flex-shrink-0 ml-auto" type="button" @click="getExisting( existingBuild.ID )">Continue</button>
            </li>
          </ul>
        </div>
        <!-- <p class="mt-10 text-center">
          <button class="btn" type="button" @click="startNewBuild()">Start New Build</button>
        </p> -->
      </div>
    </div>
  </template>

  <template v-if="currentPage === 3">
    <div class="vc-builder__wrapper items-center">
      <div class="vc-builder__container container">
        <p class="mb-12 text-3xl font-bold text-center">Let’s get you set up!</p>
        <div class="max-w-sm mx-auto">
          <div v-if="errorMessage" class="bg-form-error p-4 mb-5 font-semibold text-white rounded-lg">
            {{ errorMessage }}
          </div>
          <div class="mb-5">
            <label for="full_name">Your Full Name</label>
            <input v-model="fullName" id="full_name" name="full_name" type="text" placeholder="">
          </div>
          <div class="mb-5">
            <label for="phone_number">Your Phone Number</label>
            <input v-model="phoneNumber" id="phone_number" name="phone_number" type="text" placeholder="">
          </div>
          <div class="mb-5">
            <label for="company_name">Company Name</label>
            <input v-model="companyName" id="company_name" name="company_name" type="text" placeholder="">
          </div>
          <div class="">
            <label for="company_website">Company Website URL</label>
            <input v-model="companyWebsite" id="company_website" name="company_website" type="text" placeholder="">
          </div>
        </div>
        <p class="mt-10 text-center">
          <button class="btn" type="button" @click="submitBasicDetails()">Continue</button>
        </p>
      </div>
    </div>
  </template>

  <template v-if="currentPage === 4">
    <div class="vc-builder__wrapper items-center">
      <div class="vc-builder__container container">
        <p class="mb-12 text-2xl font-bold text-center">Describe your clientele</p>
        <div class="max-w-lg mx-auto">
          <div v-if="errorMessage" class="bg-form-error p-4 mb-5 font-semibold text-white rounded-lg">
            {{ errorMessage }}
          </div>

          <div class="flex -mx-3">
            <div class="flex-initial w-1/3 px-3">
              <div :class="{ 'selected': clientTypes.toString() === 'woman' }" class="vc-builder__treatment-checkbox bg-brand-off-white border-brand-off-white flex flex-wrap w-full h-full p-3 text-left border rounded-lg">
                <input v-model="clientTypes" type="radio" name="client_types" id="client_type_women" :value="['woman']">
                <label for="client_type_women">Women</label>
              </div>
            </div>
            <div class="flex-initial w-1/3 px-3">
              <div :class="{ 'selected': clientTypes.toString() === 'man' }" class="vc-builder__treatment-checkbox bg-brand-off-white border-brand-off-white flex flex-wrap w-full h-full p-3 text-left border rounded-lg">
                <input v-model="clientTypes" type="radio" name="client_types" id="client_type_men" :value="['man']">
                <label for="client_type_men">Men</label>
              </div>
            </div>
            <div class="flex-initial w-1/3 px-3">
              <div :class="{ 'selected': clientTypes.toString() === 'woman,man' }" class="vc-builder__treatment-checkbox bg-brand-off-white border-brand-off-white flex flex-wrap w-full h-full p-3 text-left border rounded-lg">
                <input v-model="clientTypes" type="radio" name="client_types" id="client_type_both" :value="['woman','man']">
                <label for="client_type_both">Both</label>
              </div>
            </div>
          </div>

        </div>
        <p class="mt-10 text-center">
          <button class="btn" type="button" @click="submitClientTypes()">Continue</button>
        </p>
      </div>
    </div>
  </template>

  <template v-if="currentPage === 5">
    <div class="vc-builder__wrapper items-center">
      <div class="vc-builder__container container">
        <p class="mb-12 text-2xl font-bold text-center">What service types do you offer?</p>
        <div class="max-w-lg mx-auto">
          <div v-if="errorMessage" class="bg-form-error p-4 mb-5 font-semibold text-white rounded-lg">
            {{ errorMessage }}
          </div>

          <div class="flex flex-wrap -mx-3 gap-y-3">
            <div v-for="procedureType in procedureTypes" :key="procedureType.slug" class="flex-initial w-1/3 px-3">
              <div :class="{ 'selected': serviceTypes.includes( procedureType.slug ) }" class="vc-builder__treatment-checkbox bg-brand-off-white border-brand-off-white flex flex-wrap w-full h-full p-3 text-left border rounded-lg">
                <input v-model="serviceTypes" type="checkbox" name="procedure_types" :id="'procedure_type_' + procedureType.slug" :value="procedureType.slug">
                <label :for="'procedure_type_' + procedureType.slug">{{ procedureType.name }}</label>
              </div>
            </div>
          </div>

        </div>
        <p class="mt-10 text-center">
          <button class="btn" type="button" @click="createNewBuild()">Continue</button>
        </p>
      </div>
    </div>
  </template>

  <template v-if="currentPage === 6">
    <div class="vc-builder__wrapper">
      <div class="vc-builder__container container">
        <div class="flex flex-wrap -mx-2">
          <div class="flex-initial w-2/3 px-2 mb-4">
            <p class="mb-3 text-2xl font-semibold">Select Your Offered Treatments</p>
            <p class="text-sm">Treatments have pre-selected concerns associated with them, if you want to modify them you can click into edit them in needed. If you do not see a treatment you offer you can create a custom treatment.</p>
          </div>
          <div class="flex-initial w-1/3 px-2 mb-4">
            <button class="btn flex items-center ml-auto" @click="addCustomTreatment()"><svg class="icon icon-plus block mr-2"><use xlink:href="#icon-plus"></use></svg> Create Custom Treatment</button>
          </div>
          <div class="flex-initial w-2/3 px-2 mb-4">
            <ul class="flex flex-wrap items-center gap-3">
              <li class="vc-builder__radio flex-initial">
                <input v-model="treatmentCategoryFilter" id="treatment-category-all" type="radio" value="">
                <label for="treatment-category-all">All</label>
              </li>
              <li v-for="procedureType in selectedProcedureTypes" :key="procedureType.slug" class="vc-builder__radio flex-initial">
                <input v-model="treatmentCategoryFilter" :id="'treatment-category-' + procedureType.slug" type="radio" :value="procedureType.slug">
                <label :for="'treatment-category-' + procedureType.slug">{{ procedureType.name }}</label>
              </li>
            </ul>
          </div>
          <div class="flex-initial w-1/3 px-2 mb-4">
            <p><input v-model="treatmentSearchTerm" class="vc-builder__search-icon" type="text" placeholder="Search treatments"></p>
          </div>
        </div>

        <div class="my-3">
          <p class="pb-3 mb-5 text-xs font-medium uppercase border-b">
            Selected Treatments ({{ selectedTreatments.length }})
            <button v-if="selectedTreatments.length > 0" @click="showTreatments = !showTreatments" class="bg-brand-indigo px-2 py-1 ml-2 font-bold text-white rounded-full">{{ showTreatments ? 'Hide' : 'Show' }}</button>
          </p>
          <ul v-if="showTreatments" class="flex flex-wrap -mx-2">
            <li v-for="selectedTreatment in selectedTreatments" :key="selectedTreatment.slug" class="flex-initial px-2 mb-2">
              <span class="border-brand-indigo bg-brand-periwinkle flex items-center px-3 py-2 text-sm font-medium leading-none border rounded-full">
                {{ selectedTreatment.post_title }} <button @click="unselectTreatment( selectedTreatment )"><svg class="icon icon-close block ml-3 text-xs"><use xlink:href="#icon-close"></use></svg></button>
              </span>
            </li>
          </ul>
        </div>

        <p v-if="treatmentSearchTerm !== ''" class="mb-4 font-semibold">Searching for treatments with "{{ treatmentSearchTerm }}"</p>
        <div class="flex flex-wrap -mx-2">
          <template v-for="treatment in treatments" :key="treatment.slug">
            <div v-if="( treatmentSearchTerm === '' || treatment.post_title.toLowerCase().includes( treatmentSearchTerm.toLowerCase() ) ) && filterTreatmentsByCategory( treatment ) && shouldDisplayTreatment( treatment )" class="flex-initial w-1/3 px-2 mb-4">

              <div :class="{ 'selected': isSelectedTreatment( treatment ) }" class="vc-builder__treatment-checkbox bg-brand-off-white border-brand-off-white flex flex-wrap w-full h-full p-3 text-left border rounded-lg">
                <div class="flex flex-initial w-full">
                  <input v-model="selectedTreatments" @change="save()" type="checkbox" name="selectedTreatments" :id="treatment.slug" :value="treatment" :disabled="isRunning">
                  <label :for="treatment.slug">
                    {{ treatment.post_title }}
                  </label>
                  <button v-if="isSelectedTreatment(treatment)" @click="goToTreatmentConcerns( treatment )" class="vc-builder__edit self-start block ml-auto text-xs font-medium leading-none cursor-pointer">Edit</button>
                </div>
                <span v-if="treatment.concerns && treatment.concerns.length > 0" class="text-ellipsis whitespace-nowrap text-form-placeholder flex-initial block w-full mt-2 overflow-hidden text-sm">
                  {{ treatment.concerns.map(concern => concern.post_title).join(', ') }}
                </span>
              </div>

            </div>
          </template>
        </div>
      </div>
    </div>
  </template>

  <template v-if="currentPage === 7">
    <div class="vc-builder__wrapper">
      <div class="vc-builder__container container">
        <div class="row">

          <div class="col border-brand-off-white w-2/3 border-r">

            <div class="flex items-center mb-2">
              <p class="text-2xl font-bold">Edit Treatment Concerns</p>
              <button class="btn flex items-center ml-auto" @click="openConcernPopup()"><svg class="icon icon-plus block mr-2"><use xlink:href="#icon-plus"></use></svg> Create New Concern</button>
            </div>

            <div class="mb-4">
              <label for="">Treatment Name</label>
              <input class="treatment-name-input" type="text" v-model="currentTreatment.post_title" name="" id="">
            </div>

            <div class="mb-3">
              <p class="pb-3 mb-5 text-xs font-medium uppercase border-b">
                Selected Concerns ({{ currentTreatment.concerns.length }})
                <button v-if="currentTreatment.concerns.length > 0" @click="showConcerns = !showConcerns" class="bg-brand-indigo px-2 py-1 ml-2 font-bold text-white rounded-full">{{ showConcerns ? 'Hide' : 'Show' }}</button>
              </p>
              <ul v-if="showConcerns" class="flex flex-wrap -mx-2">
                <li v-for="concern in currentTreatment.concerns" :key="concern.slug" class="flex-initial px-2 mb-2">
                  <span class="border-brand-indigo bg-brand-periwinkle flex items-center px-3 py-2 text-sm font-medium leading-none border rounded-full">
                    {{ concern.post_title }} <button @click="unselectConcern( concern )"><svg class="icon icon-close block ml-3 text-xs"><use xlink:href="#icon-close"></use></svg></button>
                  </span>
                </li>
              </ul>
            </div>

            <div class="mb-5">
              <p class=""><input v-model="concernSearchTerm" class="vc-builder__search-icon" type="text" placeholder="Search concerns"></p>
              <p v-if="concernSearchTerm !== ''" class="mt-3 font-semibold">Searching for concerns with "{{ concernSearchTerm }}"</p>
            </div>

            <div class="flex flex-wrap -mx-2">
              <template v-for="concern in concerns" :key="concern.slug">
                <div v-if="(concernSearchTerm === '' || concern.post_title.toLowerCase().includes( concernSearchTerm.toLowerCase() ) )" class="flex-initial w-1/2 px-2 mb-4">
                  <div :class="{ 'selected': isSelectedConcern( concern ) }" class="vc-builder__treatment-checkbox bg-brand-off-white border-brand-off-white flex items-center w-full px-3 py-4 text-left border rounded-lg">
                    <input v-model="currentTreatment.concerns" @change="save()" type="checkbox" name="selectedConcerns" :id="concern.slug" :value="concern" :disabled="isRunning">
                    <label :for="concern.slug">
                      {{ concern.post_title }}
                    </label>
                    <span class="vc-builder__concern-tooltip border-brand-dark-gray inline-flex items-center justify-center w-4 h-4 ml-auto text-xs leading-none border rounded-full"
                      data-toggle-class-on-target="is-visible"
                      data-toggle-target-self=".tooltip"
                      data-toggle-event="mouseover"
                      data-toggle-outside
                      :aria-describedby="'tooltip_' + concern.slug">
                      ?
                      <span class="tooltip"
                        :id="'tooltip_' + concern.slug"
                        role="tooltip"
                        aria-hidden="true">
                        <p class="font-base mb-4 font-semibold">This concern applies to:</p>
                        <p class="flex mb-4">
                          <template v-for="body in bodySections" :key="body.slug">
                            <div v-if="shouldDisplayBodyPart( concern, body )" class="flex-initial flex-grow flex-shrink-0 w-1/2">
                              <table class="vc-builder__body-table">
                                <thead>
                                  <tr>
                                    <th>
                                      {{ body.name }}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <template v-for="part in body.children" :key="part.slug">
                                    <template v-if="part.children.length > 0">
                                      <template v-for="subPart in part.children" :key="subPart.slug">
                                        <tr v-if="shouldDisplayBodyPart( concern, subPart )">
                                          <td>
                                            {{ subPart.name }}
                                          </td>
                                        </tr>
                                      </template>
                                    </template>
                                    <template v-else>
                                      <tr v-if="shouldDisplayBodyPart( concern, part )">
                                        <td>
                                          {{ part.name }}
                                        </td>
                                      </tr>
                                    </template>
                                  </template>
                                </tbody>
                              </table>
                            </div>
                          </template>
                        </p>
                        <p class="text-xs italic">*You will be able to modify these once your form has been submitted later if needed.</p>
                      </span>
                    </span>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <div class="col vc-builder__treatment-sidebar self-start w-1/3 mb-10">

            <p class="mb-4 text-2xl font-bold">Edit Treatment Details</p>

            <div class="mb-2">
              <label for="">Type</label>
              <div v-for="procedureType in selectedProcedureTypes" :key="procedureType.slug" class="flex items-center">
                <input class="mb-2" v-model="currentTreatment.types" type="radio" name="procedure_type" :id="'procedure_type_' + procedureType.slug" :value="[procedureType.slug]">
                <label class="pl-2 cursor-pointer" :for="'procedure_type_' + procedureType.slug">{{ procedureType.name }}</label>
              </div>
            </div>

            <div class="mb-4">
              <label for="treatment_description">Description</label>
              <textarea v-model="currentTreatment.description" name="treatment_description" id="treatment_description"></textarea>
            </div>

            <div class="mb-4">
              <label for="treatment_type">Procedure Type</label>
              <input type="text" v-model="currentTreatment.details.procedure_type" name="treatment_type" id="treatment_type">
            </div>

            <div class="mb-4">
              <label for="treatment_length">Procedure Length</label>
              <input type="text" v-model="currentTreatment.details.procedure_length" name="treatment_length" id="treatment_length">
            </div>

            <div class="mb-4">
              <label for="back_to_work">Back to Work</label>
              <input type="text" v-model="currentTreatment.details.back_to_work" name="back_to_work" id="back_to_work">
            </div>

            <div class="mb-4">
              <label for="recovery_time">Recovery Time</label>
              <input type="text" v-model="currentTreatment.details.recovery_time" name="recovery_time" id="recovery_time">
            </div>

            <div class="mb-4">
              <label for="duration_of_results">Duration of Results</label>
              <input type="text" v-model="currentTreatment.details.duration_of_results" name="duration_of_results" id="duration_of_results">
            </div>

            <div class="">
              <label for="number_of_treatments">Number of Treatments</label>
              <input type="text" v-model="currentTreatment.details.number_of_treatments" name="number_of_treatments" id="number_of_treatments">
            </div>
          </div>

        </div>
      </div>
    </div>
  </template>

  <template v-if="currentPage === 8">
    <div class="vc-builder__wrapper items-center">
      <div class="vc-builder__container container">
        <p class="mb-5 text-3xl font-bold text-center">Edit Your Consultation</p>
        <p class="max-w-lg mx-auto mb-8 text-center">This will be the message displayed to a user after they have completed their Virtual Consultation on your website. <span class="font-semibold">Please let them know what to expect—including when they might hear back from you—and what to do next.</span> We’ve provided a basic message to get you started.</p>
        <div class="max-w-sm mx-auto">
          <div v-if="errorMessage" class="bg-form-error p-4 mb-5 font-semibold text-white rounded-lg">
            {{ errorMessage }}
          </div>
          <div class="mb-5">
            <label for="from_email_address">"From" Email Address</label>
            <input v-model="notificationEmailFrom" id="from_email_address" name="from_email_address" type="text" placeholder="">
          </div>
          <div class="mb-5">
            <label for="email_subject">Email Subject</label>
            <input v-model="notificationEmailSubject" id="email_subject" name="email_subject" type="text" placeholder="">
          </div>
          <div class="">
            <label for="email_body">Email Body</label>
            <textarea v-model="notificationEmailBody" name="email_body" id="email_body"></textarea>
          </div>
        </div>
        <!-- <p class="mt-10 text-center">
          <button class="btn" type="button" @click="submitBasicDetails()">Continue</button>
        </p> -->
      </div>
    </div>
  </template>

  <template v-if="currentPage === 9">
    <div class="vc-builder__wrapper items-center">
      <div class="vc-builder__container container">
        <div class="max-w-3xl mx-auto">
          <svg class="icon icon-finished block text-[296px] mb-12 mx-auto"><use xlink:href="#icon-finished"></use></svg>
          <p class="mb-8 text-4xl font-bold text-center">Thank You!</p>
          <p class="text-lg text-center">We appreciate your collaboration. Please take a moment to relax, your Project Manager will soon connect with you to conclude the development of your personalized Treatment Planning Tool.</p>
        </div>
      </div>
    </div>
  </template>

  <div id="vc-builder-add-concern-popup" class="mfp-hide">
    <div class="vc-builder__add-concern-popup overflow-hidden rounded-lg">

      <div class="p-8 bg-white">
        <p class="mb-3 text-2xl font-semibold">Create New Concern</p>

        <div class="mb-4">
          <label for="">Concern Name</label>
          <input type="text" v-model="newConcernName" name="" id="">
        </div>
        <p class="mb-5 text-sm">Please select the body areas related to this concern.</p>

        <div class="row">

          <div v-for="body in bodySections" :key="body.slug"  class="col flex-grow flex-shrink-0 w-1/2">

            <p class="mb-4 text-lg font-semibold">{{ body.name }} Body</p>
            <ul class="mb-8">

              <template v-for="part in body.children" :key="part.slug">
                <template v-if="part.children.length > 0">
                  <template v-for="subPart in part.children" :key="subPart.slug">
                    <li class="vc-builder__body-section-checkbox mb-3">
                      <input v-model="newConcernAreas" type="checkbox" :id="`body_section_${subPart.slug}`" name="body" :value="{ 'name': subPart.name, 'slug': subPart.slug }">
                      <label :for="`body_section_${subPart.slug}`">{{ subPart.name }}</label>
                    </li>
                  </template>
                </template>
                <template v-else>
                  <li class="vc-builder__body-section-checkbox mb-3">
                    <input v-model="newConcernAreas" type="checkbox" :id="`body_section_${part.slug}`" name="body" :value="{ 'name': part.name, 'slug': part.slug }">
                    <label :for="`body_section_${part.slug}`">{{ part.name }}</label>
                  </li>
                </template>
              </template>
            </ul>
          </div>

        </div>
      </div>

      <div class="bg-brand-wicked flex justify-end px-4 py-2">
        <button class="hover:underline p-3 font-semibold text-white" @click="closeConcernPopup()">Cancel</button>
        <button class="btn" @click="addCustomConcern()">Save New Concern</button>
      </div>

    </div>
  </div>

  <div v-if="currentPage !== 1 && currentPage !== 2 && currentPage !== 3 && currentPage !== 9" class="bg-brand-wicked fixed bottom-0 left-0 right-0 text-white">
    <div class="container py-2">
      <div class="flex items-center">

        <template v-if="currentPage === 4">
          <button class="flex items-center font-semibold" @click="currentPage = 3"><svg class="icon icon-back block mr-2 text-2xl"><use xlink:href="#icon-back"></use></svg> Back</button>
        </template>

        <template v-if="currentPage === 5">
          <button class="flex items-center font-semibold" @click="currentPage = 4"><svg class="icon icon-back block mr-2 text-2xl"><use xlink:href="#icon-back"></use></svg> Back</button>
        </template>

        <template v-if="currentPage === 6">
          <button class="btn ml-auto" @click="currentPage = 8; save()">Finish Selecting Treatments</button>
        </template>

        <template v-if="currentPage === 7">
          <button class="flex items-center font-semibold" @click="currentPage = 6; save()"><svg class="icon icon-back block mr-2 text-2xl"><use xlink:href="#icon-back"></use></svg> Back</button>
          <button @click="currentPage = 6; save()" class="btn ml-auto">Finish Modifying Concerns</button>
        </template>

        <template v-if="currentPage === 8">
          <button class="flex items-center font-semibold" @click="currentPage = 6"><svg class="icon icon-back block mr-2 text-2xl"><use xlink:href="#icon-back"></use></svg> Back</button>
          <button class="btn ml-auto" @click="submitEmailDetails()">Submit Treatment Builder</button>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
const axios = require('axios');

import { ref, watch, nextTick, provide, computed } from 'vue';
const props = defineProps(['procedureTypesProp']);

// Ensure the procedureTypesProp is an array
const procedureTypes = computed(() => Array.isArray(props.procedureTypesProp) ? props.procedureTypesProp : []);
const isRunning = ref(false);
// Post ID of the VC Build post we're editing
const postID = ref(false);
// All Treatments.Concerns.Areas
const treatments = ref( [] );
// All Concerns
const concerns = ref( [] );
// Body Sections
const bodySections = ref( [] );
// Error Message
const errorMessage = ref( false );
// Basic Details
const emailAddress = ref( '' );
const fullName = ref( '' );
const phoneNumber = ref( '' );
const companyName = ref( '' );
const companyWebsite = ref( '' );
// Filter Details
const clientTypes = ref( false );
const serviceTypes = ref( [] );
// Filter the procedureTypesProp based on serviceTypes
const selectedProcedureTypes = computed(() => {
  return procedureTypes.value.filter(procedureType =>
    serviceTypes.value.includes(procedureType.slug)
  );
});
// Search Terms
const treatmentSearchTerm = ref( '' );
const treatmentCategoryFilter = ref( '' );
const concernSearchTerm = ref( '' );
// Visibility of selected treatments and concerns
const showTreatments = ref( true );
const showConcerns = ref( true );
// Matching VC Build posts with entered email address
const existingBuilds = ref( false );
// Page number for moving through the form
const currentPage = ref( 1 );
// User's checked treatments (and their data) and concerns for each treatment (nested in each treatment)
const selectedTreatments = ref( [] );
// The currently selected treatment for selecting concerns and editing data
const currentTreatment = ref( false )
// New conern details
const newConcernName = ref( '' )
const newConcernAreas = ref( [] )
// Notification Email
const notificationEmailFrom = ref( '' );
const notificationEmailSubject = ref( 'Your Virtual Consultation Results' );
const notificationEmailBody = ref( 'Thank you for filling out our virtual consultation form!<br><br>Your customized results have been saved and you can return to our site to view your results at any time. Please click below to view your results on our website.' );

function startNewBuild() {
  // TODO: make sure to clear out any values other than email
  currentPage.value = 3;
}

/**
 * Create ll_vc_build post
 */
function createNewBuild() {

  errorMessage.value = false;

  if ( serviceTypes.value.length === 0 ) {
    errorMessage.value = 'Please make a selection.'
  }

  if ( ! isRunning.value && ! errorMessage.value ) {

    isRunning.value = true;
    axios( {
        method: 'POST',
        url: `${siteInfo.wpApiSettings.ll}vc-builder/create`,
        headers: {
          'X-WP-Nonce': siteInfo.wpApiSettings.nonce,
          'X-Requested-With': 'XMLHttpRequest'
        },
        data: {
          email: emailAddress.value,
          full_name: fullName.value,
          phone_number: phoneNumber.value,
          company_name: companyName.value,
          company_website: companyWebsite.value,
          client_types: clientTypes.value,
          service_types: serviceTypes.value,
        }
      } )
      .then( response => {
        const data = response.data;
        // console.log( data );
        isRunning.value = false;
        if ( data.success ) {
          postID.value = data.data.post_id;
          treatments.value = data.data.treatments;
          concerns.value = data.data.concerns;
          bodySections.value = data.data.body_sections;
          currentPage.value = 6;
        } else {
          console.error( 'Error:', data.data.message );
        }
      } )
      .catch( error => {
        console.error( 'Error:', error );
      } )
      .finally( () => {
      } );
  }
}

function submitEmail() {
  var regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  errorMessage.value = false;

  if( regex.test( emailAddress.value ) ) {

    if ( ! isRunning.value ) {
      isRunning.value = true;
      axios( {
        method: 'POST',
        url: `${siteInfo.wpApiSettings.ll}vc-builder/email`,
        headers: {
          'X-WP-Nonce': siteInfo.wpApiSettings.nonce,
          'X-Requested-With': 'XMLHttpRequest'
        },
        data: {
          email: emailAddress.value,
        }
      } )
      .then( response => {
        isRunning.value = false;
        if ( response.data ) {
          existingBuilds.value = response.data;
          currentPage.value = 2;
        } else {
          existingBuilds.value = false;
          currentPage.value = 3;
        }
      } )
      .catch( error => {
        errorMessage.value = 'Error: ' + error;
      } )
      .finally( () => {
      } );
    }
  } else {
    // TODO: Handle invalid email
    errorMessage.value = 'Please enter a valid email address.'
  }
}

function getExisting( id ) {

  if ( ! isRunning.value ) {
    isRunning.value = true;
    axios( {
      method: 'POST',
      url: `${siteInfo.wpApiSettings.ll}vc-builder/get-metadata`,
      headers: {
        'X-WP-Nonce': siteInfo.wpApiSettings.nonce,
        'X-Requested-With': 'XMLHttpRequest'
      },
      data: {
        post_id: id,
      }
    } )
    .then( response => {
      isRunning.value = false;

      treatments.value = response.data.data.treatments;

      // Map over user_selections to find the corresponding treatment objects
      selectedTreatments.value = response.data.data.user_selections.map(selected => {
        return treatments.value.find(treatment => treatment.slug === selected.slug); // Replace 'id' with the actual key you use to identify treatments
      }).filter(Boolean);  // Remove any undefined elements

      concerns.value = response.data.data.concerns;
      clientTypes.value = response.data.data.client_types;
      serviceTypes.value = response.data.data.service_types;
      bodySections.value = response.data.data.body_sections;
      if ( response.data.data.email_from ) {
        notificationEmailFrom.value = response.data.data.email_from;
      }
      if ( response.data.data.email_subject ) {
        notificationEmailSubject.value = response.data.data.email_subject;
      }
      if ( response.data.data.email_body ) {
        notificationEmailBody.value = response.data.data.email_body;
      }
      postID.value = id;
      currentPage.value = 6;
    } )
    .catch( error => {
      console.error('Error:', error);
    } )
    .finally( () => {
    } );
  }
}

function save() {

  if ( ! isRunning.value ) {
    isRunning.value = true;
    axios( {
      method: 'POST',
      url: `${siteInfo.wpApiSettings.ll}vc-builder/set-metadata`,
      headers: {
        'X-WP-Nonce': siteInfo.wpApiSettings.nonce,
        'X-Requested-With': 'XMLHttpRequest'
      },
      data: {
        post_id: postID.value,
        user_selections: selectedTreatments.value,
        treatments: treatments.value,
        concerns: concerns.value
      }
    } )
    .then( response => {
      isRunning.value = false;
    } )
    .catch( error => {
      console.error('Error:', error);
    } )
    .finally( () => {
    } );
  }
}

function formatDateTime( dateTimeStr ) {
  const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' };
  const date = new Date( dateTimeStr );
  return date.toLocaleDateString( 'en-US', options );
}

function isSelectedTreatment( treatment ) {
  if (selectedTreatments && selectedTreatments.value) {
    return selectedTreatments.value.some(selected => selected.slug === treatment.slug);
  }
  return false;
}

function isSelectedConcern( concern ) {
  return currentTreatment.value.concerns.some(selected => selected.slug === concern.slug);
}

// function goToTreatmentConcerns( treatment, event ) {
//   if ( event.target.checked ) {
//     // The treatment has been selected, open the concerns page
//     currentPage.value = 5;
//     currentTreatment.value = treatment;
//   }
// }

function goToTreatmentConcerns( treatment ) {
  // The treatment has been selected, open the concerns page
  currentPage.value = 7;
  currentTreatment.value = treatment;
    // scroll window to top of page
    window.scrollTo({
    top: 0,
    left: 0,
  } );
}

function filterTreatmentsByCategory( treatment ) {
  if ( treatmentCategoryFilter.value !== '' && Array.isArray( treatment.types ) ) {
    return treatment.types.includes(treatmentCategoryFilter.value);
  }
  return true;
}

function addCustomTreatment() {
  const newTreatment = {
    categories: [],
    concerns: [],
    description: '',
    details: {
      back_to_work: '',
      duration_of_results: '',
      number_of_treatments: '',
      precedure_length: '',
      procedure_type: '',
      recovery_time: '',
    },
    post_title: '',
    slug: uuidv4(),
    types: [
      'aesthetic'
    ],
  };

  treatments.value.unshift( newTreatment );

  // Go to edit page, add to selected treatments
  currentPage.value = 7;
  currentTreatment.value = newTreatment;
  selectedTreatments.value.push( newTreatment );

  save();
}

function closeConcernPopup() {
  $.magnificPopup.close();
}

function openConcernPopup() {
  $.magnificPopup.open( {
    items: {
      src: '#vc-builder-add-concern-popup',
    },
    type: 'inline',
    fixedContentPos: true,
    fixedBgPos: true,
    overflowY: 'auto',
    closeBtnInside: true,
    preloader: false,
    midClick: true,
    removalDelay: 300,
  }, 0 );
}

function addCustomConcern() {
  const newConcern = {
    areas: newConcernAreas.value,
    post_title: newConcernName.value,
    slug: uuidv4()
  };

  concerns.value.unshift( newConcern );
  currentTreatment.value.concerns.push( newConcern );

  newConcernName.value = '';
  newConcernAreas.value = [];

  nextTick( function() {
    window.easyToggleState();
  } );

  closeConcernPopup();
  save();
}

// Used to generate a random slug.
function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0,
        v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

function unselectTreatment( treatment ) {
  const index = selectedTreatments.value.findIndex(item => item.slug === treatment.slug);
  if (index !== -1) {
    selectedTreatments.value.splice(index, 1);
    save();
  }
};

function unselectConcern(concernToRemove) {
  const index = currentTreatment.value.concerns.findIndex(function(concern) {
    return concern.slug === concernToRemove.slug;
  });

  if (index !== -1) {
    currentTreatment.value.concerns.splice(index, 1);
    save();
  }
}

function shouldDisplayTreatment( treatment ) {
  if ( treatment.types.length > 0 ) {
    return treatment.types.some( function( typeSlug ) {
      return serviceTypes.value.includes( typeSlug );
    } );
  } else {
    return true;
  }
}

function shouldDisplayBodyPart( concern, part ) {
  return concern.areas.some( area => area.slug === part.slug );
}

function submitBasicDetails() {
  errorMessage.value = false;

  if ( companyName.value === '' ) {
    errorMessage.value = 'Please enter your company name.';
  }

  if ( phoneNumber.value === '' ) {
    errorMessage.value = 'Please enter your phone number.';
  }

  if ( fullName.value === '' ) {
    errorMessage.value = 'Please enter your name.';
  }

  if ( ! errorMessage.value ) {
    currentPage.value = 4;
  }
}

function submitClientTypes() {
  errorMessage.value = false;

  if ( ! clientTypes.value ) {
    errorMessage.value = 'Please make a selection.';
  }

  if ( ! errorMessage.value ) {
    currentPage.value = 5;
  }
}

function submitEmailDetails() {
  errorMessage.value = false;

  if ( notificationEmailBody.value === '' ) {
    errorMessage.value = 'Please enter content for your email.';
  }

  if ( notificationEmailSubject.value === '' ) {
    errorMessage.value = 'Please enter a subject for the email.';
  }

  if ( notificationEmailFrom.value === '' ) {
    errorMessage.value = 'Please enter a sending email address.';
  }

  if ( ! errorMessage.value ) {
    submit();
  }
}

function submit() {

  if ( ! isRunning.value ) {
    isRunning.value = true;
    axios( {
      method: 'POST',
      url: `${siteInfo.wpApiSettings.ll}vc-builder/submit`,
      headers: {
        'X-WP-Nonce': siteInfo.wpApiSettings.nonce,
        'X-Requested-With': 'XMLHttpRequest'
      },
      data: {
        post_id: postID.value,
        email_from: notificationEmailFrom.value,
        email_subject: notificationEmailSubject.value,
        email_body: notificationEmailBody.value,
      }
    } )
    .then( response => {
      isRunning.value = false;
      currentPage.value = 9;
    } )
    .catch( error => {
      console.error('Error:', error);
    } )
    .finally( () => {
    } );
  }
}

// Watcher to initialize easy toggle state tooltips
watch( currentPage, function( newPage ) {
  if ( newPage === 7 ) {
    nextTick( function() {
      window.easyToggleState();
    } );
  }
} );

watch( newConcernAreas, function( values ) {

  const manIndex = values.findIndex( obj => obj.slug === 'man' );
  const hasMan = values.some( obj => obj.slug.startsWith( 'man_' ) );

  if ( manIndex === -1 && hasMan ) {
    values.push(
      {
        name: 'Man',
        slug: 'man'
      }
    )
  } else if ( manIndex > -1 && !hasMan ) {
    values.splice( manIndex, 1 );
  }

  const womanIndex = values.findIndex( obj => obj.slug === 'woman' );
  const hasWoman = values.some( obj => obj.slug.startsWith( 'woman_' ) );

  if ( womanIndex === -1 && hasWoman ) {
    values.push(
      {
        name: 'Woman',
        slug: 'woman'
      }
    )
  } else if ( womanIndex > -1 && !hasWoman ) {
    values.splice( womanIndex, 1 );
  }
} );

</script>
